import{VisuallyHidden as i}from"radix-ui";const d=i.Root,e=i.Root;export{e as Root,d as VisuallyHidden};
//# sourceMappingURL=visually-hidden.js.map
